import * as Sentry from '@sentry/react';

export default function throwWithoutBreaking(
  error: Error,
  captureContext?: Parameters<typeof Sentry.captureException>[1],
) {
  Sentry.captureException(error, captureContext);
}
